import { render, staticRenderFns } from "./HostCamera.vue?vue&type=template&id=f7be87ce&scoped=true&"
import script from "./HostCamera.vue?vue&type=script&lang=js&"
export * from "./HostCamera.vue?vue&type=script&lang=js&"
import style0 from "./HostCamera.vue?vue&type=style&index=0&id=f7be87ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7be87ce",
  null
  
)

export default component.exports